import { DEBUG } from "./settings";

export function checkStringByRegexPattern(regexPattern, the_string){
    const isValid = regexPattern.test(the_string);
    return isValid;
}

export function consoleLog(logString){
    if (DEBUG === true){
        console.log(logString);
    }
}